const firstStepConstants = {
	flights : [
               { value: 1, label: 'House'},
               { value: 2, label: 'Apartment'},
               { value: 3, label: 'Condo'},
               { value: 4, label: 'Townhome'},
               { value: 5, label: 'Storage'},
               { value: 6, label: 'Commercial'},
               { value: 7, label: 'High Rise' }
        ],
	moveSizesHouse : [
                { value: 1, label: '1 story', floor: 1 },
                { value: 2, label: '2 story', floor: 2 },
                { value: 3, label: '3 story', floor: 3 }
	], 
  moveSizesApartment : [
                { value: 1, label: '1st floor w/ elevator', floor: 1 },
                { value: 2, label: '1st floor without elevator', floor: 1 },
                { value: 3, label: '2nd floor w/ elevator', floor: 2 },
                { value: 4, label: '2nd floor without elevator', floor: 2 },
                { value: 5, label: '3rd floor w/ elevator', floor: 3 },
                { value: 6, label: '3rd floor without elevator', floor: 3 },
                { value: 7, label: '4th floor and above', floor: 5 }
  ], 
  moveSizesHigh : [
                { value: 1, label: 'Floor 1 to 5 with elevator', floor: 4 },
                { value: 2, label: 'Floor 1 to 5 without an elevator', floor: 4 },
                { value: 3, label: 'Floor 5 to 15', floor: 4 },
                { value: 4, label: 'Floor 15 or above', floor: 5 }
  ], 
  storageOption : [
                { value: 1, label: 'Short Term'},
                { value: 2, label: 'Non-Temp' }
  ],
  baseLocationFW :  {
          lat: 32.7284045,
          lng: -97.4487747
  },
  baseLocationA :  {
          lat: 30.4291984,
          lng: -97.6815664
  },
  baseLocationDA :  {
          lat: 32.8899954,
          lng: -96.6700936
  },
  baseLocationH :  {
          lat: 30.3379004,
          lng: -96.6380081
  }
};

export default firstStepConstants;


// WEBPACK FOOTER //
// ./src/common/Constants.js